import { OverLayFields } from '../models/OverlayFields';
import { PositioningType } from '../models/PositioningType';

export const UnicoLRPPositioning: PositioningType[] = [
  {
    overlayField: OverLayFields.LastGoodScan,
    position: { x: 0, y: 0 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.ApiDesignation,
    position: { x: 0, y: 0 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.CurrentCommunicationStatus,
    position: { x: 216, y: 253 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.RunStatus,
    position: { x: 216, y: 285 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.TimeInState,
    position: { x: 216, y: 316 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.ControllerType,
    position: { x: 216, y: 354 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.Protocol,
    position: { x: 216, y: 392 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.HostName,
    position: { x: 216, y: 430 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.Port,
    position: { x: 216, y: 469 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.RTUAddress,
    position: { x: 216, y: 507 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.Offset,
    position: { x: 216, y: 545 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.OPCType,
    position: { x: 216, y: 583 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.PumpingUnit,
    position: { x: 577, y: 237.91 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.StructuralLoading,
    position: { x: 577, y: 274.92 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.StrokeLength,
    position: { x: 577, y: 312.92 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.StrokesPerMinute,
    position: { x: 577, y: 352 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.TubingPressure,
    position: { x: 577, y: 430 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.CasingPressure,
    position: { x: 577, y: 468.01 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.RodStrings,
    position: { x: 361, y: 625 },
    justification: 'right',
  },
  {
    overlayField: OverLayFields.PumpFillage,
    position: { x: 577, y: 625 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.RodLoading,
    position: { x: 577, y: 663 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.PumpDepth,
    position: { x: 577, y: 701 },
    justification: 'left',
  },
  {
    overlayField: OverLayFields.PumpType,
    position: { x: 577, y: 740 },
    justification: 'left',
  },
];
